import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from 'src/app/shared/services/token/interceptor';
//import { AspiranteService } from 'src/app/shared/services/postulaciones/aspirante/aspirante.service';
//import { TipoNotaService } from 'src/app/shared/services/postulaciones/tipoNota/tipoNota.service';
import { TipoOfertaService } from '../tipoOferta/tipoOferta.service';
//import { TipoOfertaAspiranteService } from '../tipoOfertaAspirante/tipoOfertaAspirante.service';
//import { TipoProgramaAcademicoService } from '../tipoProgramaAcademico/tipoProgramaAcademico.service';
import { PeriodoService } from '../periodo/periodo.service';
import { ProcesoInscripcionService } from '../procesoInscripcion/procesoInscripcion.service';
//import { EtapasService } from '../etapas/etapas.service';
//import { DocumentosAdjuntoService } from '../documentosAdjunto/documentosAdjunto.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { TipoProgramaService } from '../tipoPrograma/tipoPrograma.service';
import { TipoDocumentoAdjuntoService } from '../tipoDocumentoAdjunto/tipoDocumentoAdjunto.service';
import { TipoEtapasService } from '../tipoEtapas/tipoEtapas.service';
import { TipoCalificacionService } from '../tipoCalificacion/tipoCalificacion.service';
import { TipoOfertaProcesoService } from '../tipoOfertaProceso/tipoOfertaProceso.service';
import { EtapasProcesoService } from '../etapasProceso/etapasProceso.service';
import { CalificacionesProcesoService } from '../calificacionesProceso/calificacionesProceso.service';
import { AspiranteService } from '../aspirante/aspirante.service';
import { InscritosService } from '../inscritos/inscritos.service';
import { InscritoOfertaService } from '../inscritoOferta/inscritoOferta.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ]
})
export class SharedAspirantesModule {
  static forRoot(): ModuleWithProviders <SharedAspirantesModule>{
    return {
      ngModule: SharedAspirantesModule,
      providers: [

        //Parámetros
        TipoOfertaService,
        TipoProgramaService,
        TipoDocumentoAdjuntoService,
        TipoEtapasService,
        TipoCalificacionService,

        //Configuración
        PeriodoService,
        TipoOfertaProcesoService,
        ProcesoInscripcionService,
        EtapasProcesoService,
        CalificacionesProcesoService,


        //Solicitudes
        AspiranteService,
        InscritosService,
        InscritoOfertaService,


        PeriodoService,
        ProcesoInscripcionService,

        //EtapasService,
        //DocumentosAdjuntoService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        },
        {
          provide: MAT_DATE_LOCALE,
          useValue: 'es-ES'
        }
      ]
    };
  }
}
